import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { LaunchDarklyService } from '@shared/services/launch-darkly.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe],
  selector: 'aux-how-it-works-modal',
  templateUrl: './how-it-works-modal.component.html',
})
export class HowItWorksModalComponent {
  launchDarklyService = inject(LaunchDarklyService);

  isApManualClearingVisible$ = this.launchDarklyService.select$(
    (flags) => flags.journal_entry_ap_manual_clearing
  );
}
